<script setup lang="ts">
import StakeList from '@/components/common/StakeList/index.vue'
import { useAppKitAccount } from '@reown/appkit/vue'
import { onMounted } from 'vue'

onMounted(() => {})
const accountData = useAppKitAccount()
</script>

<template>
  <div class="relative w-screen bg-[#FAF8F6]">
    <div class="bg-handle">
      <slot></slot>
      <StakeList v-if="accountData.address" />

      <div class="hidden lg:block">
        <img class="icon icon-1" src="@img/common/bg-icon-1.svg" alt="" />
        <img class="icon icon-2" src="@img/common/bg-icon-2.svg" alt="" />
        <img class="icon icon-3" src="@img/common/bg-icon-1.svg" alt="" />
        <img class="icon icon-4" src="@img/common/bg-icon-2.svg" alt="" />
      </div>
    </div>
  </div>
</template>

<style scoped lang="less">
.bg-handle {
  position: relative;
  min-height: 100vh;
  padding-bottom: 40px;
  background:
    url('@img/common/bg-shadow.png') center 220px / 800px 800px no-repeat,
    url('@img/common/bg.svg') center 100px / contain no-repeat;
  .icon {
    position: absolute;
    z-index: 0;
    &.icon-1 {
      left: 40px;
      top: 625px;
      width: 80px;
      height: 80px;
      animation: float-rotate 6s ease-in-out infinite;
    }
    &.icon-2 {
      left: 200px;
      top: 340px;
      width: 40px;
      height: 40px;
      animation: float-rotate 3s ease-in-out infinite;
    }
    &.icon-3 {
      right: 200px;
      top: 392px;
      width: 26px;
      height: 26px;
      animation: float-rotate 2s ease-in-out infinite;
    }
    &.icon-4 {
      right: 40px;
      top: 660px;
      width: 60px;
      height: 60px;
      animation: float-rotate 5s ease-in-out infinite;
    }
  }
}

@keyframes float-rotate {
  0% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-20px);
  }
  100% {
    transform: translateY(0px);
  }
}
</style>
